import Patient from "core/models/patient";
import JournalEventModel from "core/models/journal-event";
export default function getAllDas28Jes(patient) {
  const answer = [...patient.das28CdaiComputedJournalEvents, ...patient.das28CrpComputedJournalEvents, ...patient.das28SdaiComputedJournalEvents, ...patient.das28VsComputedJournalEvents];
  return answer;
}